import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Wrapper from './Wrapper';
import WrapperNew from './WrapperNew';
import PrivacyScreen from './screens/privacyScreen/privacyScreen';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<WrapperNew />} />
        <Route path="/after-fixes" element={<Wrapper />} />
        <Route path="/privacy" element={<PrivacyScreen />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
